import React, { useEffect, useRef, useState } from "react";
import profile from "../../../assets/images/Profile.png";
import Dashboard from "../../Dashboard";
import useGetEmail from "../../../hooks/GetEmail";
import { toast } from "react-toastify";
import axios from "axios";
import { useParams } from "react-router-dom";

function Setting(props) {
  const [editMode, setEditMode] = useState(false);
  const [base64Image, setBase64Image] = useState("");
  const [image, setImage] = useState(null);
  const [name, setName] = useState("");
  const imageref = useRef(null);
  const { email } = useGetEmail();
  const { id } = useParams();

  const handleEdit = () => {
    console.log(name);
    axios
      .post("https://aipricingtool-python.onrender.com/edit_profile", {
        email: email.useremail,
        user_identifier: id,
        new_username: name,
        image_base64: base64Image,
      })
      .then((res) => {
        // window.location.reload();
      });
    setTimeout(() => {
      setEditMode(false);
      toast.success("Profile Successfully Updated");
    }, 1800);
  };

  const handlecancel = () => {
    setName("");
    setEditMode(false);
  };

  const handleFileInputChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();

      reader.onloadend = () => {
        // Once the file is loaded, convert it to Base64
        setBase64Image(reader.result);
        console.log("base64Image", reader.result);
      };

      // Read the file as a data URL

      reader.readAsDataURL(file);
      setImage(URL.createObjectURL(file));
    }
  };

  useEffect(() => {
    console.log(email.username);
    setName(email.username);
    if (email.username === "Null") {
      setName("");
    }
  }, [email.username]);

  return (
    <Dashboard>
      <div className="custom_height md:mb-5 2xl:mb-auto px-5 md-px-auto mt-5 ">
        <div className="setting w-full md:max-w-[700px] 2xl:max-w-[864px] mb-5 m-auto px-5 md:px-20 2xl:px-40 mt-10 pt-5 md:pt-16  2xl:pt-28 pb-5 md:pb-16 2xl:pb-40 h-[80%]">
          <div className="boxes flex flex-col gap-8  ">
            <div className="box gap-3 md:gap-0 flex-col md:flex-row flex w-full justify-between items-center">
              <label className="  md:text-left text-2xl font-semibold primary w-full md:w-[40%] ">
                {editMode ? "Update Profile Picture" : "Profile Picture"}
              </label>
              <div
                onClick={() => imageref.current.click()}
                className="profile w-full md:w-[70%] cursor-pointer gap-3 justify-center flex items-center"
              >
                <div className="img w-14 h-14  rounded-[50%]   overflow-hidden ">
                  {editMode && image ? (
                    <img src={image} alt="" className="h-full w-full" />
                  ) : (
                    <img
                      src={
                        image ||
                        (email.image_base64 && email.image_base64 != "Null"
                          ? email.image_base64
                          : profile)
                      }
                      alt=""
                      className="h-full w-full"
                    />
                  )}
                </div>
                <p>Upload image</p>
                <input
                  type="file"
                  ref={imageref}
                  accept="image/*"
                  onChange={handleFileInputChange}
                  className="hidden"
                  disabled={editMode ? false : true}
                />
              </div>
            </div>

            <div className=" gap-3 md:gap-0  flex-col   md:flex-row box flex w-full justify-between items-center">
              <label
                htmlFor=""
                className="primary text-xl font-semibold  w-full md:w-[30%] "
              >
                {editMode ? "Update Name:" : "Name:"}
              </label>
              <div className="input w-full md:w-[70%] ">
                <input
                  type="text"
                  value={name ? name : null}
                  onChange={(e) => setName(e.target.value)}
                  className="w-full px-[18px] py-[7px] rounded focus:ring-0 focus:outline-none focus:border-[#6B2B4B]   border-[#6B2B4B] border-[1px]"
                  placeholder="Enter Your Name Here..."
                  disabled={editMode ? false : true}
                />
              </div>
            </div>

            <div className="box gap-3 md:gap-0  flex-col md:flex-row flex w-full justify-between items-center">
              <label
                htmlFor=""
                className="primary font-semibold  w-full md:w-[30%] text-xl"
              >
                Email Address
              </label>
              <div className="input w-full md:w-[70%] ">
                <input
                  type="email"
                  value={email.useremail}
                  className="w-full rounded focus:ring-0 focus:outline-none focus:border-[#6B2B4B] border-[#6B2B4B] border-[1px]"
                  placeholder="Type here"
                  disabled
                />
              </div>
            </div>
          </div>

          <div className="w-100 flex gap-x-14 my-5 justify-end">
            <button
              onClick={editMode ? () => handleEdit() : () => setEditMode(true)}
              className={`py-2.5 text-white rounded-lg w-[116px] Campton `}
              style={{
                background:
                  "linear-gradient(102deg, #D73E3E 20.86%, #6B2B4B 120.36%)",
              }}
            >
              {editMode ? "Save" : "Edit"}
            </button>
            {editMode && (
              <button
                onClick={() => handlecancel()}
                className={`py-2.5 text-black rounded-lg w-[116px] Campton`}
                style={{
                  border: "2px solid var(--Inside-layout-Gradient, #D73E3E)",
                }}
              >
                Cancel
              </button>
            )}
          </div>
        </div>
      </div>
    </Dashboard>
  );
}

export default Setting;
